export enum CmsProductStatusEnum {
  coming = "coming",
  active = "active",
  expiring = "expiring",
  suspended = "suspended",
  closed = "closed",
}
